import type { PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"
import type { PriceChangeFilterFormValues } from "@/screens/Pricing/schema/PriceChangeFilterFormSchema"
import type { PriceChangeSearchParams } from "@/screens/Pricing/types/searchParams"

export const toPriceChangeFilterFormValues = (searchParams: PriceChangeSearchParams): PriceChangeFilterFormValues => {
  const {
    changeType = null,
    supplierId = null,
    customerIds = [],
    effectiveDate = null,
    productCategoryId = null,
    productClassId = null,
    specificProductIds = [],
    shipFromId = null,
    shipToId = null,
    productManagerId = null,
  } = searchParams

  return {
    changeType,
    supplierId,
    customerIds,
    productCategoryId,
    productClassId,
    specificProductIds,
    shipFromId,
    shipToId,
    effectiveDate,
    productManagerId,
  }
}

export function validateInputOptions({
  data,
  options,
}: {
  data?: string | null
  options?: PriceChangeFilterLookupItem[]
}): string | undefined

export function validateInputOptions({
  data,
  options,
}: {
  data?: string[]
  options?: PriceChangeFilterLookupItem[]
}): string[]

export function validateInputOptions({
  data,
  options,
}: {
  data?: string | string[] | null
  options?: PriceChangeFilterLookupItem[]
}): string | string[] | undefined {
  if (Array.isArray(data)) {
    if (!options?.length) return []

    return data.filter((el) => options.some((option) => option.id === el))
  }

  if (!data || !options?.length) {
    return undefined
  }

  return options.some((option) => option.id === data) ? data : undefined
}
